module.exports = __webpack_public_path__ + "img/logo-menu.b714272d.png";